import React, { useContext } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const PayRateWageRenderer = (params) => {
  const {
    rowData: { summarized, subRows, payroll },
    columnData: { key }
  } = params;

  const { currency } = useContext(ConfigContext);
  if (summarized || subRows) {
    return <></>;
  }

  const { wage } = payroll || {};

  if ((wage || []).length === 0) {
    return <></>;
  }
  const wages = wage.map((current) => `${currency}${current[key]} (${current.tag?.name})`).join(', ');

  return <>{wages}</>;
};

export default PayRateWageRenderer;
